import React from 'react';

import { PageTitle } from '../../../components';
import { MonthlyRental } from '../..';



const MonthlyRentalPage = () => {  

  return (  
    <>  

      {/* Page Title */}
      <PageTitle title={'月租停車服務'} page={'上班通勤的好選擇'} />

      {/* Services Section */}
      <MonthlyRental />

    </>
  )
  
}

export default MonthlyRentalPage;